/** Libraries */
import { ToastProvider } from "@moltech/molui/toast";
import { GridDefaults } from "@moltech/molui/molgrid";

/** Navigation */
import AppRoutes from "./navigation/AppRoutes";
import { MenuProvider } from "./context/MenuContext";
import { ComponentNavigation } from "./navigation/ComponentNavigation";

/** CSS */
import "./App.scss";

GridDefaults.set({
  grid: {
    scrollable: true,
    scrollHeight: "flex",
    filterDisplay: "row",

    sortMode: "single",
    showGridlines: true,
    resizableColumns: true,

    paginator: true,
    rowsPerPageOptions: [10, 25, 50, 100],
    rows: 25,
  },
  column: {
    defaults: {
      filter: true,
      sortable: true,
    },
    datetime: {
      format: "mm/dd/yyyy",
    },
  },
});

const App = () => {
  return (
    <>
      
      <ToastProvider />
      <MenuProvider>
        <AppRoutes componentRoutes={ComponentNavigation} />
      </MenuProvider>
    </>
  );
};

export default App;
